import { render, staticRenderFns } from "./zip-upload.vue?vue&type=template&id=3086bf21"
import script from "./zip-upload.vue?vue&type=script&lang=js"
export * from "./zip-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports